export const DEFAULT_HTTP_TIMEOUT_MS = 10000

const parseTimeoutMs = value => {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null
}

export const resolveHttpTimeoutMs = (...candidates) => {
  for (const candidate of candidates) {
    const parsed = parseTimeoutMs(candidate)
    if (parsed !== null) return parsed
  }
  return DEFAULT_HTTP_TIMEOUT_MS
}
